import { render } from "./LoginAuth.vue?vue&type=template&id=7352b7b1"
import script from "./LoginAuth.vue?vue&type=script&lang=js"
export * from "./LoginAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__